import { getAdminOffset } from './helper/helper';

(function ($) {
	"use_strict";

	// checkout payment selection
	$('.woocommerce-checkout .wc_payment_methods input[type="radio"]:checked').prop('checked', true);

	$('.scroll-to').on('click', function () {
		const scrollTo = $(this).data('scrollTo');

		if (!scrollTo || !document.querySelector(scrollTo)) {
			return;
		}

		let offset = getAdminOffset();

		let offsetElement = document.querySelector($(this).data('offsetElement'));
		if (offsetElement) {
			offset += offsetElement.offsetHeight;
		}

		gsap.to(window, {
			duration: 1,
			scrollTo: {
				y: scrollTo,
				offsetY: offset + 1
			},
			ease: "power1.out"
		});
	});

	let siteSwitchTimeline = gsap.timeline({
		paused: true,
		onComplete: function () {
			$('.site-switch').attr('aria-expanded', true);
		}
	});
	siteSwitchTimeline.to($('.site-switch--dropdown'), 0.3, { autoAlpha: 1, display: 'block' });
	siteSwitchTimeline.to($('.site-switch--dropdown-icon'), 0.3, { rotateX: '180deg' }, '<')

	$('.site-switch')
		.on('mouseenter', () => siteSwitchTimeline.play())
		.on('mouseleave', () => siteSwitchTimeline.reverse());


	$('.auto-splide').each(function () {
		let splide = new Splide(this);
		splide.mount();
	});

	$('.quantity input[type="number"]').each(function () {
		const qty = $(this).parents('.quantity');
		const input = qty.find('input[type="number"]');
		qty.append('<div class="quantity-controls"><button class="quantity-control quantity-minus">&#9660</button><button class="quantity-control quantity-plus">&#9650;</button></div>');

		qty.find('.quantity-control.quantity-minus').on('click', function (e) {
			e.preventDefault();
			let min = parseInt(input.attr('min'));
			min = isNaN(min) ? 1 : min;
			// decrement the number input field by one not going below zero or the minimum input's min attribute
			if (input.val() > min || input.val() === '') {
				input.val(parseInt(input.val()) - 1);
				input.trigger('change');
			}
		});

		qty.find('.quantity-control.quantity-plus').on('click', function (e) {
			e.preventDefault();
			// increment the number input field by one not going above the maximum input's max attribute if it is set
			let max = parseInt(input.attr('max'))
			if (isNaN(max) || input.val() < max) {
				input.val(parseInt(input.val()) + 1);
				input.trigger('change');
			}
		});
	});

	setUpQtyButton();
	function setUpQtyButton() {
		$('.quantity input[type="number"]').each(function () {
			if ($('.quantity-controls .quantity-control').length > 0) {
				return;
			}

			const qty = $(this).parents('.quantity');
			const input = qty.find('input[type="number"]');

			qty.append('<div class="quantity-controls"><button class="quantity-control quantity-minus">&#9660</button><button class="quantity-control quantity-plus">&#9650;</button></div>');

			qty.find('.quantity-control.quantity-minus').on('click', function (e) {
				e.preventDefault();
				let min = parseInt(input.attr('min'));
				min = isNaN(min) ? 1 : min;
				// decrement the number input field by one not going below zero or the minimum input's min attribute
				if (input.val() > min || input.val() === '') {
					input.val(parseInt(input.val()) - 1);
					input.trigger('change');
				}
			});

			qty.find('.quantity-control.quantity-plus').on('click', function (e) {
				e.preventDefault();
				// increment the number input field by one not going above the maximum input's max attribute if it is set
				let max = parseInt(input.attr('max'))
				if (isNaN(max) || input.val() < max) {
					input.val(parseInt(input.val()) + 1);
					input.trigger('change');
				}
			});
		});
	}

	$(document.body).on('updated_wc_div', () => setUpQtyButton());
})(jQuery);
